import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class XlMapperService {


  url = environment.serverAPI9 + "/api/leadEntity/upload/advanced";

  url1 = environment.serverAPI9 + "/api/dealsEntity/upload/advanced";

  ur3 = environment.serverAPI4 + "/api/product/upload/advanced";

  url4 = environment.serverAPI4 + "/api/taskEntity/upload/advanced";

  url5 = environment.serverAPI9 + "/api/companyEntity/upload/advanced";

  url6 = environment.serverAPI5 + "/api/brand/upload/advanced";

  constructor(private http: HttpClient) { }



  updateXl(leadXl: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, leadXl);
  }

  updateDealXl(dealXl: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url1}`, dealXl);
  }

  updateProductXl(productXl: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.ur3}`, productXl);
  }

  updateTaskXl(taskXl: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url4}`, taskXl);
  }

  updateCompaniesXl(companyXl: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url5}`, companyXl);
  }

  getNotificationStatus(notificationId: any): Observable<any> {
    return this.http.get(`${environment.serverAPI4}/api/adminNotification/${notificationId}`);
  }

  updateBrandXl(brandXl: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url6}`, brandXl);
  }

}
